<figure class="media" [ngClass]="cssContainerClasses()" [class.is--svg]="media()?.fileExtension === 'svg'">
  @switch (mediaType$()) {
    @case ('video') {
      <video
        #videoElement
        [once]="false"
        [threshold]="0.3"
        (fstrInViewport)="inviewVideo($event)"
        [attr.playsinline]="videoOptions$().playsinline"
        [muted]="videoOptions$().muted"
        [loop]="videoOptions$().loop"
        [controls]="videoOptions$().controls"
        class="media media--video d-block {{ cssClasses() }}"
        [style.width]="width() || media()?.width || 1900"
        [style.height]="height() || media()?.height || 600"
        [style.--default-aspect-ratio]="aspectRatio$()"
        [class.media-cover]="fill()"
      >
        <source [src]="media()!.absoluteUrl" type="video/mp4" />
      </video>
    }
    @case ('image') {
      @if (fill() && media()?.fileExtension !== 'svg') {
        <img
          #imageElement
          (fstrInViewport)="inviewImage($event)"
          [once]="true"
          [threshold]="0.1"
          [class]="'media media--image d-block ' + cssClasses()"
          [ngSrc]="media()!.absoluteUrl"
          [sizes]="sizes()"
          [ngSrcset]="ngSrcset()"
          [alt]="media()?.altText || 'Media image'"
          [attr.data-object-position]="media()?.anchor"
          [loaderParams]="{
            width: width() || media()?.width || 1059,
            height: height() || media()?.height || 785,
            anchor: media()?.anchor || 'middlecenter',
          }"
          [style.--default-aspect-ratio]="aspectRatio$()"
          [fill]="true"
          [class.media-cover]="fill()"
          [priority]="priority()"
        />
      } @else {
        <img
          #imageElement
          (fstrInViewport)="inviewImage($event)"
          [once]="true"
          [threshold]="0.1"
          [class]="'media media--image d-block ' + cssClasses()"
          [ngSrc]="media()!.absoluteUrl"
          [width]="width() || media()?.width || 1059"
          [height]="height() || media()?.height || 785"
          [sizes]="sizes()"
          [ngSrcset]="ngSrcset()"
          [alt]="media()?.altText || 'Media image'"
          [attr.data-object-position]="media()?.anchor"
          [loaderParams]="{
            width: width() || media()?.width || 1059,
            height: height() || media()?.height || 785,
            anchor: media()?.anchor || 'middlecenter',
          }"
          [style.--default-aspect-ratio]="aspectRatio$()"
          [priority]="priority()"
        />
      }
    }
    @default {
      <img
        [src]="placeholderIconUrl()"
        [alt]="null"
        class="media media--placeholder {{ cssClasses() }}"
        [width]="width() || media()?.width || 1059"
        [height]="height() || media()?.height || 785"
        [style.--default-aspect-ratio]="aspectRatio$()"
      />
    }
  }

  <ng-content></ng-content>
</figure>
